export const availableDrivers = [
  {
    id: '1',
    name: 'Carlos Rodríguez',
    rating: 4.9,
    experience: '8 años',
    languages: ['Español', 'Inglés'],
    vehicle: 'Toyota RAV4 2022',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
    specialties: ['Volcanes', 'Playas'],
    totalTrips: 1247
  },
  {
    id: '2',
    name: 'María González',
    rating: 4.8,
    experience: '6 años',
    languages: ['Español', 'Inglés', 'Francés'],
    vehicle: 'Honda CR-V 2023',
    photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150',
    specialties: ['Naturaleza', 'Cultura'],
    totalTrips: 892
  },
  {
    id: '3',
    name: 'José Martínez',
    rating: 4.7,
    experience: '10 años',
    languages: ['Español', 'Inglés'],
    vehicle: 'Mercedes Sprinter 2021',
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
    specialties: ['Grupos grandes', 'Tours largos'],
    totalTrips: 1856
  }
];